module.exports = __webpack_public_path__ + "img/98ccc7785a7a9e381bc5842346930774.png";